<template>
  <div class="vip-detail-refund-group-orders">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="vipDetailRefundGroupOrders.orders"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="returnId"
          :label="$t('vipDetailRefundGroupOrders.refundId')"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="orderId"
          :label="$t('vipDetailRefundGroupOrders.order')"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="prodName"
          :label="$t('vipDetailRefundGroupOrders.product')"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="buyerName"
          :label="$t('vipDetailRefundGroupOrders.buyer')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="buyerCount"
          :label="$t('vipDetailRefundGroupOrders.purchaseQuantity')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="groupPrice"
          :label="$t('vipDetailRefundGroupOrders.groupPrice')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="returnMoney"
          :label="$t('vipDetailRefundGroupOrders.refundAmount')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailRefundGroupOrders.refundType')"
          align="center"
          width="150"
        >
          <template #default="{row}">
            {{ row.returnType === '1001' ? $t('vipDetailRefundGroupOrders.selfRefund') : $t('vipDetailRefundGroupOrders.groupFailedRefund') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="reason"
          :label="$t('vipDetailRefundGroupOrders.refundReason')"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="state"
          :label="$t('vipDetailRefundGroupOrders.status')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="stateMsg"
          :label="$t('vipDetailRefundGroupOrders.reviewNote')"
          align="center"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="margin-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryShopRefundGroupOrder } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailRefundGroupOrders',
  data() {
    return {
      vipDetailRefundGroupOrders: {
        orders: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailRefundGroupOrders.link = data.tel
      this.loadRefundGroupOrdersData()
    },
    loadRefundGroupOrdersData() {
      if (!this.vipDetailRefundGroupOrders.link) return
      
      this.loading = true
      const params = {
        link: this.vipDetailRefundGroupOrders.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      queryShopRefundGroupOrder(params)
        .then(res => {
          this.vipDetailRefundGroupOrders.orders = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取拼团退单数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadRefundGroupOrdersData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadRefundGroupOrdersData()
    }
  }
}
</script>

<style scoped>
.vip-detail-refund-group-orders {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>